<template>
  <b-container fluid class="px-0">
    <div class="position-relative content-div">
      <MyAccountTopOffer />
      <MyAccountCategoriesCards 
      v-on:navigate="navigate($event)" 
      :customerInfo="customerInfo"/>
      <component
              :is="contentComponent"
              @updated="contentUpdated"
              :customerInfo="customerInfo"
              :customerLastSubscription="customerLastSubscription"
            />
    </div>
  </b-container>
</template>

<script>
import MyAccountTopOffer from "@/components/centre/my-account/MyAccountTopOffer.vue";
import MyAccountCategoriesCards from "@/components/centre/my-account/MyAccountCategoriesCards.vue";
import Profile from "@/components/centre/my-account/Profile.vue";
import Billing from "@/components/centre/my-account/Billing.vue";
import Invoices from "@/components/centre/my-account/Invoices.vue";
import SubscriptionDetails from "@/components/centre/my-account/SubscriptionDetails.vue";


export default {
  title: "Center My Account",
  name: "CentreMyAccount",
  props: ["page", "customerInfo", "customerLastSubscription"],
  components: {
    MyAccountTopOffer,
    MyAccountCategoriesCards,
    SubscriptionDetails,
    Profile,
    Billing,
    Invoices,
  },
    mounted() {
    let target = this.page ? this.page : "SubscriptionDetails";
    if (this.$route.params.page) {
      target = this.$route.params.page;
    }
    console.log("navigating to " + target);
    this.navigate(target);
  },
  data() {
    return {
      content: null,
      // customerInfo: null,
      menuItems: ["Perks", "App", "Academy", "Premium", "Free", "Referral"],
    };
  },
  computed: {
    contentComponent() {
      return this.content;
    },
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      //this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    },
  },
};
</script>

<style lang="scss">
/* ====GENERAL================================================== */
html,
body,
#app {
  height: 100%;
}
/* ====Hide toolbar============================================= */
body::-webkit-scrollbar {
  display: none;
}
html {
  scrollbar-width: none;
}
</style>

<style scoped lang="scss">
$bg-gray: #f7f7f7;
$bg-footer-dark-gray: #d9d9d9;

main {
  overflow-x: hidden;
  height: 100%;
}

.marketplace-container {
  margin-top: 1rem;
  justify-content: center;
  display: flex;
}

.content-div {
  max-width: 1000px;
}

.manager-subscriptions {
    padding-left: 0;
}

.billing-history, .container-internal {
  max-width: 100%;
  padding-left: 0;
}

.child-footer {
  width: 100vw;
  //margin: auto;
  position: relative;
  left: calc(-50vw + 50%);

  background-color: $bg-footer-dark-gray;

  margin-top: 5rem;
}

@media screen and (max-width: 1023px) {
  .marketplace-container {
    display: block;
  }
}
</style>
